import styles from "./translateButton.module.css";

const TranslateIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const RevertIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 7v6h6" />
    <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6.36 2.64L3 13" />
  </svg>
);

interface TranslateButtonProps {
  label: string;
  isTranslated: boolean;
  isLoading: boolean;
  onClick: () => void;
  ariaLabel: string;
  variant?: "inline" | "action";
  className?: string;
}

const TranslateButton = ({
  label,
  isTranslated,
  isLoading,
  onClick,
  ariaLabel,
  variant = "inline",
  className,
}: TranslateButtonProps) => {
  const buttonClassName = [
    styles.translateButton,
    variant === "action" ? styles.translateButton_action : "",
    isTranslated ? styles.translateButton_translated : "",
    isLoading ? styles.translateButton_loading : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={buttonClassName}
      onClick={onClick}
      disabled={isLoading}
      aria-label={ariaLabel}
      title={label}
    >
      {isTranslated ? <RevertIcon /> : <TranslateIcon />}
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export default TranslateButton;
